export default function LoadingSpinner() {
  return (
    <div className="size-10">
      <svg
        className="size-full animate-spin"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="20" cy="20" r="18" stroke="#F2F2F2" strokeWidth="3" />
        <path
          d="M38 20C38 10.0589 29.9411 2 20 2"
          stroke="#17642A"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
